<template>
  <vs-card>
    <h4 class="mb-4">Students</h4>
    <div class="cstm_vuexy_table table-responsive">
      <table class="w-full">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Courses</th>
            <th style="width: 50px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(eachData, index) in students" :key="index">
            <td>
              {{ eachData.first_name }}
            </td>
            <td>
              {{ eachData.last_name }}
            </td>
            <td>
              {{ eachData.email }}
            </td>
            <td>
              {{ eachData.phone }}
            </td>
            <td>
              <span
                @click="courseModal(eachData.courses)"
                class="material-icons-outlined cursor-pointer"
                >library_books</span
              >
            </td>
          </tr>
          <tr v-if="students.length==0" class="text-center">
            <td colspan="5">No students found</td>
          </tr>
        </tbody>
      </table>
      <pagination
        style="float: right"
        :meta="meta"
       @page-change="handlePageChange"
      />
   </div>
    <div v-if="coursePopup">
      <vs-popup class="holamundo" title="Courses" :active.sync="coursePopup">
        <div class="cstm_vuexy_table table-responsive">
          <table class="w-full">
            <thead>
              <tr>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(eachData, index) in courses" :key="index">
                <td>
                  {{ eachData.name }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import { studentsFetchByStaff } from '@/api/teacher'
import Pagination from '@/components/common/pagination'
export default {
  components: {
    Pagination
  },
  mounted () {
    // this.fetchStudents()
  },
  data () {
    return {
      customer_id: localStorage.getItem('customer_id'),
      operations_user_id: this.$route.params.teacher_id ? this.$route.params.teacher_id : JSON.parse(localStorage.getItem('userInfo')).id,
      students: [],
      coursePopup: false,
      courses: [],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      }
    }
  },
  methods: {
    handlePageChange (page) {
      this.meta.current_page = page || 1
      setTimeout(() => {
        this.fetchStudents()
      }, 0)
    },
    async courseModal (courseList) {
      this.coursePopup = true
      this.courses = courseList
    },
    async fetchStudents () {
      try {
        const payload = {
          limit:10
        }
        const { data } = await studentsFetchByStaff(
          this.customer_id,
          this.operations_user_id,
          this.meta.current_page,
          payload
        )
        this.students = data.data.students
        this.meta = data.data.meta
      } catch (e) {
        //
      }
    }
  }
}
</script>
